import styled from "styled-components";
import COLORS from "shared/constants/colors";

const Heading = styled.div`
  width: 100%;
  border-top: 2px solid #bbbdbf;
  border-bottom: 2px solid #bbbdbf;
  padding: 16px 0;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
`;
const Container = styled.div`
  min-height: calc(100vh - 180px);
  padding: 0 15px;
  background-color: ${COLORS.LIGHT_GREY};
`;

const Error = styled.div`
  color: #000;
  padding: 20px;
  font-weight: bold;
  font-size: 14px;
  border-radius: 10px;
  margin: 20px 0px;
  box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff;
  background-color: #ffffff;
`;

const ShirtlyUpdate = styled.div`
  display: flex;
  align-items: center;
  color: red;
  font-size: 20px;
`;

const FulfillmentWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  grid-gap: 30px;
  color: #000;
  > div {
    flex: 1;
    box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff;
    padding: 10px;
  }
`;

const ApprovedKyc = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export {
  Container,
  Heading,
  Error,
  ShirtlyUpdate,
  FulfillmentWrapper,
  ApprovedKyc,
};
